import {Record, Map} from "immutable"

enum Type {
    Profession = 1,
    Speciality = 2,
    Bachelor   = 3,
    Master     = 4,
    Specialist = 5,
    Phd        = 6,
}

const typeNames = {
    [Type.Profession]:  "Профессия",
    [Type.Speciality]:  "Специальность",
    [Type.Bachelor]:    "Бакалавр",
    [Type.Master]:      "Магистр",
    [Type.Specialist]:  "Специалист",
    [Type.Phd]:         "Аспирант",
}

const categories = {
    [Type.Profession]:  "СПО",
    [Type.Speciality]:  "СПО",
    [Type.Bachelor]:    "ВО",
    [Type.Master]:      "ВО",
    [Type.Specialist]:  "ВО",
    [Type.Phd]:         "Асп.",
}

interface Properties {
    id: number
    code: string
    type: Type
    title: string
    priority: string
    bachelorSpecialityId?: number
    period: number
}

export class Speciality extends Record({
    id: undefined,
    code: undefined,
    type: undefined,
    title: undefined,
    priority: undefined,
    bachelorSpecialityId: undefined,
    period: undefined,
}) implements Properties {
    id: number
    code: string
    type: Type
    title: string
    priority: string
    bachelorSpecialityId: number | undefined
    readonly period: number

    constructor(values: Properties) {
        super(values)
    }

    get typeName(): string {
        return typeNames[this.type]
    }

    get category(): string {
        return categories[this.type]
    }

    isVo = () => (this.type === Type.Bachelor) || (this.type === Type.Master) || (this.type === Type.Specialist)
    isSpo = () => (this.type === Type.Speciality) || (this.type === Type.Profession)
    isPhD = () => this.type === Type.Phd
    isMaster = () => (this.type === Type.Master)
    isNuclear = () => [
        '14.03.01p',
        '14.04.01p',
        '14.03.02p',
        '14.04.02p',
        '14.03.03p',
        '14.04.03p',
        '14.05.01p',
        '14.05.02p',
        '14.05.03p',
        '14.05.04p',
        '18.05.02p',
        '14.03.01',
        '14.03.02',
        '14.03.03',
        '14.04.01',
        '14.04.02',
        '14.05.01',
        '14.05.02',
        '14.05.03',
        '14.05.04',
        '18.05.02',
        '38.04.01p',
    ].some(code => this.code.startsWith(code))
}

export type JsonData =  {
    id: number
    code: string
    type: number
    title: string
    priority: string
    bachelorSpecialityId?: number
    period: number
}

export const fromJs = ({
    id,
    code,
    type,
    title,
    priority,
    bachelorSpecialityId,
    period,
}: JsonData): Speciality => new Speciality({
    id,
    code,
    type,
    title,
    priority,
    bachelorSpecialityId,
    period,
})

export type Specialities = Map<number, Speciality>